import React, { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";

const UserRoute = memo(function UserRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);

  useEffect(() => {
    if (session?.status === "unauthorized") {
      navigate("/authentication");
    } else if (
      session?.status === "authorized" &&
      session?.user?.roleCode === "ADMIN"
    ) {
      navigate("/admin/dashboard");
    }
  }, [session?.status, session?.user?.roleCode, navigate]);

  if (session?.status === "loading") {
    return <LoadingFallback />;
  }

  return session?.status === "authorized" && session?.user?.roleCode === "USER"
    ? children
    : null;
});

export default UserRoute;
